import { is } from '@common/is/is'

import type { TData } from '../definitions'

interface IProps {
  readonly type?: 'text' | 'number' | 'color' | 'date' | 'password' | 'hidden'
  readonly name?: string
  readonly value?: string | number | null
  readonly placeholder?: string
  readonly min?: number | string
  readonly max?: number | string
  readonly isDisabled?: boolean
  readonly data?: TData
  readonly onInput?: (e: Event) => void
  readonly onEnter?: (e: KeyboardEvent) => void
  readonly id?: string
  readonly isRequired?: boolean
  readonly spellcheck?: boolean
  readonly isValid?: boolean | undefined
  readonly isInvalid?: boolean
  readonly shouldValidate?: boolean
  readonly maxLength?: number
}

/**
 * Bootstrap-alapú input komponens.
 * @param props - JSX props {@link IProps}.
 */
export default function Input (props: IProps): HTMLInputElement {
  const type = props.type ?? 'text'

  let validateClass: 'is-valid' | 'is-invalid' | '' = ''

  if (props.shouldValidate) {
    validateClass = is.empty((props?.value ?? '').toString().trim()) ? 'is-invalid' : 'is-valid'
  }

  // eslint-disable-next-line custom/no-nested-ternary -- Legacy.
  validateClass = is.boolean(props.isValid) ? props.isValid ? 'is-valid' : 'is-invalid' : validateClass

  const cn: string[] = [
    'form-control',
    validateClass
  ]

  if (props.isInvalid) {
    cn.push('is-invalid')
  }

  const input: HTMLInputElement = (
    <input
      className={ cn }
      type={ type }
      { ...(props.data ? { data: props.data } : {}) }
    />
  )

  if (is.number(props.maxLength)) {
    input.maxLength = props.maxLength
  }

  if (props.min) {
    input.min = `${ props.min }`
  }

  if (props.max) {
    input.max = `${ props.max }`
  }

  if (props.placeholder) {
    input.placeholder = props.placeholder
  }

  if (props.name) {
    input.name = props.name
  }

  if (is.boolean(props.spellcheck)) {
    input.spellcheck = props.spellcheck
  }

  if (is.nonNullable(props.value)) {
    input.value = `${ props.value }`
  }

  if (props.isDisabled) {
    input.disabled = true
  }

  if (props.isRequired) {
    input.required = true
  }

  if (props.id) {
    input.id = props.id
  }

  if (props.onInput) {
    input.addEventListener('input', props.onInput)
  }

  if (is.function(props.onEnter)) {
    input.addEventListener('keypress', (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        // @ts-expect-error Ez hülye.
        props.onEnter(e)
      }
    })
  }

  return input
}
